// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageView from 'syft-acp-core/components/PageView'
import WorkerPointTransactionsListWrapper from 'syft-acp-core/entities/WorkerPointTransactions/WorkerPointTransactionsListWrapper'
import { recordLabel, useWorkerName } from 'syft-acp-core/components/PageTitle'
import { WorkerSubNavigation } from './SubNavigation'

type Props = RouteComponentProps<{
  id: string
}>

export const EntityWorkersPointTransactionsList = ({ match: { params } }: Props) => {
  const workerName = useWorkerName(Number(params.id))

  return (
    <>
      <WorkerSubNavigation workerID={params.id} />
      <PageView title={['Levels transactions', recordLabel('Worker', params.id, workerName)]}>
        <WorkerPointTransactionsListWrapper workerID={params.id} />
      </PageView>
    </>
  )
}
